import Enumerable from "linq";
import Loading from 'quasar/src/plugins/loading/Loading.js';import Notify from 'quasar/src/plugins/notify/Notify.js';
import { isEmpty } from "validate.js";
import { computed, defineComponent, onMounted, reactive, ref, watch } from "vue";
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { GetHanyoParam } from "~/api/Common/Commands";
import { api } from "~/api/index";
import BankSelectField from "~/components/BankSelectField.vue";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { MsgBox } from "~/components/MsgBox";
import { auth } from "~/core/Auth";
import { convertFullToHalf, Log } from "~/extensions/utils";
import { createAddress } from "~/extensions/utils/AddressHelper";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { HanyoKb, PageID, RoomSb } from "~/extensions/utils/DefineTypes";
import { HanyoHelper } from "~/extensions/utils/HanyoHelper";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
import { ShinjoCarValidator, ShinjoEmergencyContactValidator, ShinjoInsuranceValidator, ShinjoKouzaValidator, ShinjoKyojushaValidator, ShinjWorkPlaceValidator } from "./Models/ShinjoEditValidator";
import { KyojushasViewModel, ShinjoEditViewModel } from "./Models/ShinjoEditViewModel";
const log = Log.create("ShinjoshoEdit");
export default defineComponent({
    name: "ShinjoshoEdit",
    components: {
        BreadcrumbList,
        BankSelectField
    },
    props: {
        viewModel: {
            type: Object,
            required: true
        }
    },
    setup() {
        const pageName = commonStore.pageName(PageID.shinjoshoEdit);
        const shinjoData = ref(new ShinjoEditViewModel());
        let personal = reactive(myPageStore.personal);
        const hasKouzaInfo = ref(false);
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        const isMt = auth.isMt;
        const isMma = computed(() => (isMt ? shinjoData.value.isMma : myPageStore.personal.isMma));
        const isParking = ref(myPageStore.selectedNyukyokeiyaku.roomSb === RoomSb.Parking);
        const route = useRoute();
        const router = useRouter();
        const kouzaNo = ref("");
        let kouzaNumber = ref("");
        let urlParameters = Number(route.query.nyukyokeiyakuNo);
        let kouzaValid = ref(new ShinjoKouzaValidator(personal, kouzaNumber.value));
        let workValid = reactive(new ShinjWorkPlaceValidator(shinjoData.value.workPlace));
        let emergencyContactValid = reactive(new ShinjoEmergencyContactValidator(shinjoData.value.emergencyContact));
        let carValid = reactive(new ShinjoCarValidator(shinjoData.value.car));
        let insuranceValid = reactive(new ShinjoInsuranceValidator(shinjoData.value.insurance));
        const kouzaForInput = ref([]);
        const isBankDialog = ref(false);
        const bankName = ref("");
        const bansName = ref("");
        const kouzaSbName = ref("");
        let kyojushaValid = reactive({});
        // テーブルカラム
        const columns = [
            { name: "", label: "", align: "center", field: "", sortable: false, headerStyle: "width: 100px; font-size: 16px; font-weight: bold" },
            { name: "name", label: "氏名（契約者以外）", align: "left", field: "name", sortable: false, headerStyle: "width: 600px; font-size: 16px; font-weight: bold" },
            { name: "rlationship", label: "続柄", align: "left", field: "rlationship", sortable: false, headerStyle: "width: 200px; font-size: 16px; font-weight: bold" },
            { name: "dateOfBirth", label: "生年月日", align: "left", field: "dateOfBirth", sortable: false, headerStyle: "width: 200px; font-size: 16px; font-weight: bold" },
            { name: "tel", label: "連絡先電話番号", align: "left", field: "tel", sortable: false, headerStyle: "width: 200px; font-size: 16px; font-weight: bold" },
            { name: "deleteBtn", label: "", align: "center", field: "deleteBt", sortable: false, headerStyle: "width: 100px; font-size: 16px; font-weight: bold" }
        ];
        // 入居者情報詳細画面に遷移したときにURLにパラメーターを追加
        onBeforeRouteLeave(to => {
            const no = urlParameters;
            if (to.name === "nyukyosha-detail" && isMt && no != null && to.query.nyukyokeiyakuNo !== String(no)) {
                return {
                    name: "nyukyosha-detail",
                    query: {
                        ...to.query,
                        nyukyokeiyakuNo: String(no)
                    }
                };
            }
        });
        // 初期表示
        const initView = async () => {
            try {
                Loading.show();
                let gethanyoParam = [new GetHanyoParam(HanyoKb.KouzaSb)];
                let hanyoList = await HanyoHelper.getHanyoList(gethanyoParam);
                const publishKbnList = hanyoList.GetByHanyoKb(HanyoKb.KouzaSb);
                kouzaForInput.value = publishKbnList
                    .filter(x => [1, 2].includes(x.value))
                    .map(x => ({
                    ...x,
                    label: x.option1
                }));
                const result = await api.keiyaku.getShinjosho(urlParameters);
                shinjoData.value = new ShinjoEditViewModel(result);
                kouzaValid.value = new ShinjoKouzaValidator(personal, kouzaNumber.value);
                workValid = reactive(new ShinjWorkPlaceValidator(shinjoData.value.workPlace));
                emergencyContactValid = reactive(new ShinjoEmergencyContactValidator(shinjoData.value.emergencyContact));
                carValid = reactive(new ShinjoCarValidator(shinjoData.value.car));
                shinjoData.value.kyojushas.forEach(x => {
                    kyojushaValid[x.index] = new ShinjoKyojushaValidator(x);
                });
                insuranceValid = reactive(new ShinjoInsuranceValidator(shinjoData.value.insurance));
                //管理者用の口座情報処理
                if (isMt) {
                    adminSetKouzaInfo(shinjoData.value.kouza);
                }
            }
            catch (ex) {
                await MsgBox.error(ex.data.errorMessage);
                log.error("find", ex);
            }
            finally {
                Loading.hide();
            }
            //口座種別初期セット
            if (personal.kouzaSb === 0 || typeof personal.kouzaSb === "undefined" || personal.kouzaSb === -1) {
                personal.kouzaSb = 1;
            }
        };
        // 選択した銀行情報を反映
        const onBankSelect = ({ bank, branch }) => {
            personal.bankCd = Number(bank.code);
            personal.bansCd = Number(branch.code);
            personal.bankName = bank.name;
            personal.bansName = branch.name;
        };
        // 半角変換
        const onKouzaKanaInput = (value) => {
            personal.kouzaKana = convertFullToHalf(value);
        };
        // 更新処理
        const onUpdate = async () => {
            if (isMt) {
                return;
            }
            kouzaValid.value = new ShinjoKouzaValidator(personal, kouzaNumber.value);
            if (kouzaValid.value.error || workValid.error || emergencyContactValid.error || carValid.error || insuranceValid.error || Object.values(kyojushaValid)?.filter(x => x.error).length > 0) {
                return;
            }
            const isUpdate = await MsgBox.confirm(commonStore.messages.PI0003);
            if (isUpdate) {
                try {
                    Loading.show();
                    if (personal.bankCd === null || personal.bansCd === null || personal.kouzaNo === null || personal.kouzaName === "" || personal.kouzaKana === "") {
                        personal.kouzaSb = 0;
                    }
                    await api.keiyaku.updateShinjosho(shinjoData.value, personal, kouzaNumber.value);
                    // 個人情報ストアのロード
                    myPageStore.load();
                    await myPageStore.waitForBasic();
                    Loading.hide();
                    Notify.create({ color: "green", position: "top", message: commonStore.messages.PI0004 });
                }
                catch (ex) {
                    await MsgBox.error(ex.data.errorMessage);
                    log.error("update", ex);
                }
                finally {
                    Loading.hide();
                }
            }
        };
        // 戻る処理
        const onBack = () => {
            if (isMt) {
                router.push({ name: "nyukyosha-detail" });
            }
            else {
                router.push({ name: "keiyaku" });
            }
        };
        // 管理者画面照会画面表示用に変換
        const adminSetKouzaInfo = (kouza) => {
            kouzaSbName.value = kouza.kouzaSb === 1 ? "普通" : kouza.kouzaSb === 2 ? "当座" : "";
            kouzaNo.value = kouza.kouzaNo === null ? "" : String(kouza.kouzaNo);
        };
        // 入居者追加
        const onInsertRow = () => {
            let data = new KyojushasViewModel();
            if (shinjoData.value.kyojushas.length > 0) {
                data.index =
                    Enumerable.from(shinjoData.value.kyojushas)
                        .select(x => x.index)
                        .max() + 1;
            }
            shinjoData.value.kyojushas.push(data);
            kyojushaValid[data.index] = new ShinjoKyojushaValidator(data);
        };
        // 入居者削除
        const onDeleteRow = (i) => {
            const index = Enumerable.from(shinjoData.value.kyojushas).indexOf(x => x.index === i);
            shinjoData.value.kyojushas.splice(index, 1);
            delete kyojushaValid[i];
        };
        // 保険情報バリデーション
        const onChangeInssrance = () => {
            insuranceValid.error;
        };
        const formatTel = (tel, target) => {
            if (tel.length !== 13) {
                let temp = tel.replace("-", "");
                if (target === "workPlace") {
                    shinjoData.value.workPlace.workplaceTel = temp.substring(0, 3) + "-" + temp.substring(3, 7) + "-" + temp.substring(7);
                }
                else if (target === "emergency") {
                    shinjoData.value.emergencyContact.tel = temp.substring(0, 3) + "-" + temp.substring(3, 7) + "-" + temp.substring(7);
                }
                else {
                    shinjoData.value.emergencyContact.workplaceTel = temp.substring(0, 3) + "-" + temp.substring(3, 7) + "-" + temp.substring(7);
                }
            }
        };
        const findAddress = async (postCode, target) => {
            try {
                if (target === "workPlace") {
                    if (workValid.errorFields.includes("workplacePostcode")) {
                        return;
                    }
                    if (postCode.length === 7) {
                        postCode = postCode.substring(0, 3) + "-" + postCode.substring(3);
                    }
                    shinjoData.value.workPlace.workplacePostcode = postCode;
                    if (/^\d{3}-\d{4}$/.test(postCode)) {
                        shinjoData.value.workPlace.address1 = await createAddress(postCode);
                    }
                }
                else if (target === "emergency") {
                    if (emergencyContactValid.errorFields.includes("postCode")) {
                        return;
                    }
                    if (postCode.length === 7) {
                        postCode = postCode.substring(0, 3) + "-" + postCode.substring(3);
                    }
                    shinjoData.value.emergencyContact.postCode = postCode;
                    if (/^\d{3}-\d{4}$/.test(postCode)) {
                        shinjoData.value.emergencyContact.address1 = await createAddress(postCode);
                    }
                }
                else {
                    if (emergencyContactValid.errorFields.includes("workplacePostcode")) {
                        return;
                    }
                    if (postCode.length === 7) {
                        postCode = postCode.substring(0, 3) + "-" + postCode.substring(3);
                    }
                    shinjoData.value.emergencyContact.workplacePostcode = postCode;
                    if (/^\d{3}-\d{4}$/.test(postCode)) {
                        shinjoData.value.emergencyContact.workplaceAddress1 = await createAddress(postCode);
                    }
                }
            }
            catch (ex) {
                // 該当する住所が存在しない場合は404が投げられる
                if (ex?.status !== 404) {
                    log.error("findAddress", ex);
                }
            }
        };
        /**ルートを書き換えた場合の処理 */
        onBeforeRouteUpdate(async (to, from) => {
            if (to.query.nyukyokeiyakuNo !== from.query.nyukyokeiyakuNo) {
                urlParameters = Number(to.query.nyukyokeiyakuNo);
                myPageStore.selectedNyukyokeiyakuNo = urlParameters;
                try {
                    let result = await api.keiyaku.getShinjosho(urlParameters);
                    shinjoData.value = new ShinjoEditViewModel(result);
                    kouzaValid.value = new ShinjoKouzaValidator(personal, kouzaNumber.value);
                    workValid = reactive(new ShinjWorkPlaceValidator(shinjoData.value.workPlace));
                    emergencyContactValid = reactive(new ShinjoEmergencyContactValidator(shinjoData.value.emergencyContact));
                    carValid = reactive(new ShinjoCarValidator(shinjoData.value.car));
                    shinjoData.value.kyojushas.forEach(x => {
                        kyojushaValid[x.index] = new ShinjoKyojushaValidator(x);
                    });
                    insuranceValid = reactive(new ShinjoInsuranceValidator(shinjoData.value.insurance));
                    let gethanyoParam = [new GetHanyoParam(HanyoKb.KouzaSb)];
                    let hanyoList = await HanyoHelper.getHanyoList(gethanyoParam);
                    const publishKbnList = hanyoList.GetByHanyoKb(HanyoKb.KouzaSb);
                    kouzaForInput.value = publishKbnList
                        .filter(x => [1, 2].includes(x.value))
                        .map(x => ({
                        ...x,
                        label: x.option1
                    }));
                }
                catch (ex) {
                    await MsgBox.error(ex.data.errorMessage);
                    log.error("find", ex);
                }
            }
        });
        watch([() => personal.bankName, () => personal.bansName, () => kouzaNumber.value, () => personal.kouzaName, () => personal.kouzaKana], () => {
            // 口座情報が1項目でも入力されているか
            hasKouzaInfo.value = !isEmpty(personal.bankName) || !isEmpty(personal.bansName) || !isEmpty(kouzaNumber.value) || !isEmpty(personal.kouzaName) || !isEmpty(personal.kouzaKana);
            // 口座情報が入力されている場合のみバリデーション
            kouzaValid.value = new ShinjoKouzaValidator(personal, kouzaNumber.value);
        }, { immediate: true });
        if (personal.kouzaNo !== null && personal.kouzaNo !== 0 && personal.kouzaNo !== -1) {
            kouzaNumber.value = personal.kouzaNo.toString().padStart(7, "0");
        }
        onMounted(async () => {
            await initView();
        });
        return {
            pageName,
            PageID,
            columns,
            isMt,
            isMma,
            isParking,
            isMultipleKeiyaku,
            shinjoData,
            kouzaSbName,
            bankName,
            bansName,
            kouzaNo,
            kouzaValid,
            workValid,
            emergencyContactValid,
            carValid,
            kyojushaValid,
            insuranceValid,
            personal,
            isBankDialog,
            kouzaNumber,
            kouzaForInput,
            hasKouzaInfo,
            onBankSelect,
            onKouzaKanaInput,
            onUpdate,
            onBack,
            adminSetKouzaInfo,
            onInsertRow,
            onDeleteRow,
            onChangeInssrance,
            formatTel,
            findAddress,
            isNullOrUndefined
        };
    }
});
